<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :showBack="true" @clickBack="goHome()"/>
        <div class="index mainContent">
            <div>
                <b-container>
                    <!-- 標題 -->
                    <PwaTitle :textTitle="title" :showMore="false"></PwaTitle>

                    <!-- 訂閱項目列表 -->
                    <div class="subscription-list">
                        <!-- 按類型分組顯示 -->
                        <div v-for="(group, typeName) in groupedItems" :key="typeName" class="subscription-group">
                            <div class="group-title">
                                <div class="group-title-left" @click="toggleGroup(typeName)">
                                    <div class="group-title-content">
                                        <span>{{ typeName }}</span>
                                        <span class="group-count">({{ getSelectedCountInGroup(group) }}/{{ group.length }})</span>
                                    </div>
                                    <i class="group-icon" :class="isGroupExpanded(typeName) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                </div>
                                <div class="group-actions" @click.stop>
                                    <b-button
                                        size="sm"
                                        variant="outline-primary"
                                        @click="selectAllInGroup(group)"
                                        class="action-btn"
                                    >
                                        全選
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="outline-secondary"
                                        @click="clearAllInGroup(group)"
                                        class="action-btn"
                                    >
                                        清除
                                    </b-button>
                                </div>
                            </div>
                            <b-collapse :visible="isGroupExpanded(typeName)">
                                <div class="subscription-items">
                                    <div
                                        v-for="item in group"
                                        :key="item.Id"
                                        class="subscription-item"
                                        @click="toggleSubscription(item.Id)"
                                    >
                                        <div class="item-content">
                                            <div class="item-info">
                                                <span class="item-name">{{ item.DisplayName }}</span>
                                            </div>
                                            <div class="item-checkbox">
                                                <b-form-checkbox
                                                    v-model="selectedItems"
                                                    :value="item.Id"
                                                    @click.native.stop
                                                ></b-form-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>

                    <!-- 保存按鈕 -->
                    <div class="save-button-wrapper">
                        <b-button
                            variant="primary"
                            block
                            size="lg"
                            @click="saveSubscriptions"
                            :disabled="isLoading"
                        >
                            {{ isLoading ? '儲存中...' : '儲存訂閱' }}
                        </b-button>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from "@/components/pwa/PwaTitle.vue";

export default {
    created() {
        window.vue = this;
        // if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        PwaTitle,
        Header
    },
    data() {
        return {
            title: "我的訂閱",
            allItems: [],           // 所有訂閱項目
            selectedItems: [],      // 已選擇的項目 ID
            isLoading: false,       // 載入狀態
            expandedGroups: [],     // 展開的類別
        }
    },
    computed: {
        // 按類型分組的項目
        groupedItems() {
            const groups = {};
            this.allItems.forEach(item => {
                const typeName = item.TypeDisplayName || '其他';
                if (!groups[typeName]) {
                    groups[typeName] = [];
                }
                groups[typeName].push(item);
            });
            return groups;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        goHome: function () {
            window.setPage("home");
        },

        // 載入資料
        loadData() {
            this.isLoading = true;
            // 先取得所有訂閱項目
            this.getAllCropSubscriptionItems();
        },

        // 切換類別展開/收合
        toggleGroup(typeName) {
            const index = this.expandedGroups.indexOf(typeName);
            if (index > -1) {
                // 已展開，收合
                this.expandedGroups.splice(index, 1);
            } else {
                // 未展開，展開
                this.expandedGroups.push(typeName);
            }
        },

        // 檢查類別是否展開
        isGroupExpanded(typeName) {
            return this.expandedGroups.includes(typeName);
        },

        // 取得類別中已勾選的數量
        getSelectedCountInGroup(group) {
            return group.filter(item => this.selectedItems.includes(item.Id)).length;
        },

        // 全選該類別的所有項目
        selectAllInGroup(group) {
            group.forEach(item => {
                if (!this.selectedItems.includes(item.Id)) {
                    this.selectedItems.push(item.Id);
                }
            });
        },

        // 清除該類別的所有項目
        clearAllInGroup(group) {
            const groupIds = group.map(item => item.Id);
            this.selectedItems = this.selectedItems.filter(id => !groupIds.includes(id));
        },

        // 取得所有訂閱項目
        getAllCropSubscriptionItems() {
            this.userRequest.get('/API/CropSubscription/all-items')
                .then((res) => {
                    this.allItems = res.data || [];
                    // 預設收合所有類別
                    // this.expandedGroups = Object.keys(this.groupedItems); // 若要預設展開所有類別，取消註解此行
                    this.expandedGroups = [];
                    // 取得所有項目後，再取得使用者已訂閱的項目
                    this.getAccountCropSubscriptionItems();
                })
                .catch((err) => {
                    console.error('取得訂閱項目失敗:', err);
                    alert('取得訂閱項目失敗，請稍後再試');
                    this.isLoading = false;
                });
        },

        // 取得使用者已訂閱的項目
        getAccountCropSubscriptionItems() {
            this.FunctionToken(this.getAccountCropSubscriptionItemsCallback, {});
        },

        // 取得使用者已訂閱的項目回調
        getAccountCropSubscriptionItemsCallback(data) {
            this.userRequest.get('/API/CropSubscription/account-items', {
                params: {
                    TokenID: data.TokenID,
                    Token: data.Token
                }
            })
                .then((res) => {
                    const accountItems = res.data || [];
                    // 將已訂閱的項目 ID 加入到 selectedItems
                    this.selectedItems = accountItems.map(item => item.CropSubscriptionItemId);
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error('取得使用者訂閱項目失敗:', err);
                    if (err.response && err.response.status === 401) {
                        alert('登入已過期，請重新登入');
                        window.setPage("login");
                    } else {
                        alert('取得使用者訂閱項目失敗，請稍後再試');
                    }
                    this.isLoading = false;
                });
        },

        // 切換訂閱狀態
        toggleSubscription(itemId) {
            const index = this.selectedItems.indexOf(itemId);
            if (index > -1) {
                this.selectedItems.splice(index, 1);
            } else {
                this.selectedItems.push(itemId);
            }
        },

        // 儲存訂閱
        saveSubscriptions() {
            this.isLoading = true;
            this.FunctionToken(this.saveSubscriptionsCallback, {});
        },

        // 儲存訂閱回調
        saveSubscriptionsCallback(data) {
            this.userRequest.post('/API/CropSubscription/account-items/update', {
                TokenID: data.TokenID,
                Token: data.Token,
                CropSubscriptionItemIds: this.selectedItems
            })
                .then((res) => {
                    if (res.data.Success) {
                        alert('訂閱清單更新成功！');
                    } else {
                        alert('訂閱清單更新失敗：' + (res.data.Message || '未知錯誤'));
                    }
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error('更新訂閱清單失敗:', err);
                    if (err.response && err.response.status === 401) {
                        alert('登入已過期，請重新登入');
                        window.setPage("login");
                    } else {
                        alert('更新訂閱清單失敗，請稍後再試');
                    }
                    this.isLoading = false;
                });
        }
    }
}
</script>
<style scoped>
.subscription-list {
    margin-top: 1rem;
}

.subscription-group {
    margin-bottom: 1.5rem;
}

.group-title {
    font-size: 1.1rem;
    font-weight: bold;
    color: #2c3e50;
    padding: 0.75rem 0.5rem;
    border-bottom: 2px solid #e0e0e0;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.25rem;
}

.group-title-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 0.25rem;
    transition: background-color 0.2s;
}

.group-title-left:hover {
    background-color: #f0f0f0;
}

.group-title-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.group-count {
    font-size: 0.9rem;
    color: #666;
    font-weight: normal;
}

.group-icon {
    font-size: 0.9rem;
    color: #666;
    transition: transform 0.3s ease;
    margin-left: 0.5rem;
}

.group-actions {
    display: flex;
    gap: 0.5rem;
    margin-left: 1rem;
}

.action-btn {
    font-size: 0.85rem;
    padding: 0.25rem 0.75rem;
    border-radius: 0.25rem;
    font-weight: 500;
}

.subscription-items {
    background-color: #f8f9fa;
    border-radius: 0.5rem;
    overflow: hidden;
}

.subscription-item {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e0e0e0;
    cursor: pointer;
    transition: background-color 0.2s;
}

.subscription-item:last-child {
    border-bottom: none;
}

.subscription-item:hover {
    background-color: #e9ecef;
}

.item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.item-info {
    flex: 1;
}

.item-name {
    font-size: 1rem;
    color: #333;
}

.item-checkbox {
    margin-left: 1rem;
}

.save-button-wrapper {
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 0 1rem;
}

.save-button-wrapper .btn {
    border-radius: 0.5rem;
    font-weight: bold;
}
</style>
